<template>
  <transition
    name="expander"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <div v-show="show" class="expander-wrapper" ref="expanderWrapper">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    triggerElement: {
      type: String,
      required: true,
    },
    timing: {
      type: String,
      default: `0.35s`,
    },
    easingFunction: {
      type: String,
      default: `ease`,
    },
  },
  data() {
    return {
      triggerElementNodes: [],
      show: false,
    };
  },
  methods: {
    toggleExpander(event) {
      event.preventDefault();
      event.stopImmediatePropagation(); 
      this.show = !this.show;
      const evt = new CustomEvent(`expansion`, {
        detail: {
          expanded: this.show,
        },
      });
      this.triggerElementNodes.forEach((node) => {
        node.dispatchEvent(evt);
      });
    },
    beforeEnter(element) {
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = `0px`;
        }
        element.style.display = null;
      });
    },
    enter(element) {
      element.style.transition = `height ${this.timing} ${this.easingFunction}`;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = `${element.scrollHeight}px`;
        });
      });
    },
    afterEnter(element) {
      element.style.height = null;
      element.style.transition = null;
    },
    beforeLeave(element) {
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = `${element.offsetHeight}px`;
        }
      });
    },
    leave(element) {
      element.style.transition = `height ${this.timing} ${this.easingFunction}`;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = `0px`;
        });
      });
    },
    afterLeave(element) {
      element.style.height = null;
      element.style.transition = null;
    },
  },
  mounted() {
    this.triggerElementNodes = Array.from(
      document.querySelectorAll(this.triggerElement)
    );
    this.triggerElementNodes.forEach((node) => {
      node.addEventListener(`click`, this.toggleExpander);
    });
  },
};
</script>

<style lang="scss" scoped>
  .expander-enter-active, .expander-leave-active {
    position: relative;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// Expander.vue?7091bd13